import POCartType from "../types/POCartType";

interface CartAction {
  type: string;
  payload?: any;
}

const initial_state = {
  cartList: [],
  totalQty: 0,
  totalTax: 0,
  totalAmount: 0,
  totalPV: 0,
};

const CartReducer = (state = initial_state, action: CartAction) => {
  switch (action.type) {
    case POCartType.CART_LIST:
      return {
        ...state,
        cartList: action.payload.data,
        totalQty: action.payload.totalQty,
        totalTax: action.payload.totalTax,
        totalAmount: action.payload.totalAmount,
        totalPV: action.payload.totalPV,
      };

    default:
      return state;
  }
};

export default CartReducer;
